import { useEffect, useMemo, useState, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { BrightnessContrast } from "@react-three/postprocessing";
import * as THREE from "three";
import {
  Environment,
  OrbitControls,
  Stage,
  useProgress,
  Html,
  } from "@react-three/drei";
import { EffectComposer, Bloom } from "@react-three/postprocessing";
import axios from "axios";
import environmentVariables from "../../../config/environmentVariables";
// import Model from './Model'
const ModalBack = `${environmentVariables?.cdnUrl}modal_back.hdr`;

export default function ThreeJSImageCharacter({ detailOfNftCentral }) {
  // const [skinID, setSkinID] = useState(detailOfNftCentral?.skinId);
  const [loadingError, setLoadingError] = useState(false);
  const [url, setUrl] = useState(null);
  const [minDistance, setMinDistance] = useState(20);
  const [screenwidth, setScreenwidth] = useState(window.innerWidth);
  useEffect(() => {
    console.log(window.innerWidth, "innerwidthinsidethreejs");
    const handleResize = () => {
      setScreenwidth(window.innerWidth);
      if (window.innerWidth <= 768) {
        setMinDistance(20);
      } else if (window.innerWidth > 768 && window.innerWidth <= 1100) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(15);
      } else if (window.innerWidth > 1100 && window.innerWidth <= 1200) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(55);
      } else if (window.innerWidth > 1200 && window.innerWidth <= 1300) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(50);
      } else if (window.innerWidth > 1300 && window.innerWidth <= 1400) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(45);
      } else if (window.innerWidth > 1400 && window.innerWidth <= 1600) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(40);
      } else if (window.innerWidth > 1600 && window.innerWidth <= 1920) {
        setMinDistance(20);
      }
    };
    handleResize();
  }, []);

  useEffect(() => {
    if (detailOfNftCentral && detailOfNftCentral?.skinId) {
      axios
        .get(
          `
${environmentVariables?.cdnUrl}${detailOfNftCentral?.skinId}.glb`
        )
        .then((res) => {
          setLoadingError(false);
          setUrl(
            `${environmentVariables?.cdnUrl}${detailOfNftCentral?.skinId}.glb`
          );
        })
        .catch((err) => {
          setLoadingError(true);
          setUrl(null);
        });
    }
  }, [detailOfNftCentral]);

  const NewModel =
    detailOfNftCentral &&
    url &&
    (() => {
      const { scene } = useLoader(GLTFLoader, url);
      const copiedScene = useMemo(() => scene.clone(), [scene]);
      // console.log(detailOfNftCentral, "detailofnftinthreejsmodel");
      const modelRef = useRef();
      return (
        <>
          <mesh
            ref={modelRef}
            castShadow // Enable casting shadows
            receiveShadow // Enable receiving shadows
          >
            <primitive
              castShadow
              object={copiedScene}
              scale={8}
              position={[0, -6, 0]}
              rotation={[0, 0, 0]}
            />
          </mesh>
        </>
      );
    });

  function Loader() {
    const { progress } = useProgress();
    return (
      <Html
        center
        style={{
          color: "#bfbfbf",
          fontSize: "80px",
          fontWeight: "700",
          textAlign: "center",
          opacity: "0.5",
        }}
      >
        {parseInt(progress)}%
      </Html>
    );
  }

  return (
    <div className="App">
      <Canvas
        className="model-canvas"
        // gl={{ antialias: false, preserveDrawingBuffer: true}}
        shadows
        camera={{ fov: 25, position: [0, 0, 34] }}
      >
        <group position={[0, -0.25, 0]}>
          {loadingError ? (
            <Html
              center
              style={
                {
                  // height: "100%",
                  // width:"300px"
                }
              }
            >
              <img
                src={`${environmentVariables?.cdnUrl}${detailOfNftCentral?.skinId}.png`}
                alt="NFT Image"
              />
            </Html>
          ) : (
            <>{NewModel && <NewModel />}</>
          )}
        </group>
        <Environment files={ModalBack} background blur={0.4} />
        <spotLight
          position={[0, 15, 1]}
          angle={Math.PI / 6}
          penumbra={0.2}
          intensity={1}
          castShadow
          color={"#dddddd"}
        />
        <spotLight
          position={[0, 20, 1]}
          angle={Math.PI / 6}
          penumbra={0.2}
          intensity={1}
          castShadow
          color={"#dddddd"}
        />

        <mesh
          receiveShadow
          rotation={[-Math.PI / 2, 0, 0]}
          position={[0, -6, 0]}
        >
          <planeBufferGeometry attach="geometry" args={[500, 500]} />
          <meshPhongMaterial attach="material" color="#e4e2e7" />
        </mesh>
        <mesh receiveShadow position={[0, 4.5, 0]} castShadow>
          <sphereGeometry args={[100, 32, 32]} />

          {
            <meshPhongMaterial
              attach="material"
              color="#908e92"
              side={THREE.DoubleSide}
            ></meshPhongMaterial>
          }
        </mesh>

        <Stage
          castShadow
          receiveShadow
          intensity={0.4}
          adjustCamera={false}
        ></Stage>
        <OrbitControls
          autoRotate
          autoRotateSpeed={0.02}
          enableZoom={true}
          minDistance={10}
          maxDistance={60}
          makeDefault
        />

        {detailOfNftCentral?.category == "uncommon" && (
          <EffectComposer disableNormalPass multisampling={8}>
            <Bloom
              luminanceThreshold={5}
              mipmapBlur
              luminanceSmoothing={3}
              intensity={1}
            />
            <BrightnessContrast
              brightness={0} // brightness. min: -1, max: 1
              contrast={0.5} // contrast: min -1, max: 1
            />
          </EffectComposer>
        )}
      </Canvas>
    </div>
  );
}
